import Head from "next/head";
import PageLayout from "@/components/PageLayout";
import ProductCollectionsService from "@/lib/services/product_collections.js";
import Paginator from '@/components/paginator';
import {useState, useRef} from 'react'; 
import Qs from 'qs'; 
import searchTranslator from '@/lib/search_translator.js'
import {loadConfig} from '@/lib/utils.js'
import Loader from "@/components/loading_animation.js";
import ProductTile from "@/components/product_tile";

function AllCollectionsPage(results) {
  const {favicon, stylesheet, page_layout, cart_enabled, collections} = results
  const renderCollection = (collect) => { 
    return  (
      <div key={collect.id} className='lexcms-collection'>
        <h3>{collect.name} </h3>
        <div className='lexcms-collection-description'>
           {collect.description}
        </div>
        <div className='lexcms-product-tile-grid-container'>
        {collect.products.map((prod, i) => {
         return (<ProductTile key={prod.id} product={prod} />)
         })
        }
        </div>
        <a className='lexcms-collection-link' href={`/lex-cms/collections/${collect.slug}`}>View {collect.name } Collection</a>
      </div>
    )
 }
  
  return (
    <PageLayout favicon={favicon} page_layout={page_layout} stylesheet={results.stylesheet} title={'All Collections'} cart_enabled={cart_enabled}>
      <section className='lexcms-all-collections-page-container'>
       <h1>All Collections</h1>
       {collections.map((collection, i) => {
         return (renderCollection(collection))
       })
      }
      </section>
    </PageLayout>
  );
}

export async function getServerSideProps(context) {
  let token = context?.req?.headers['lex-api-token'] 

  let service = await ProductCollectionsService.build(token, context.req?.headers.host)
  let q =  searchTranslator(context.query)
  let apiFriendlyQ = searchTranslator(context.query, true)
  let search = await service.index(apiFriendlyQ)
  search.initialSearch = q
  let pageLayout = loadConfig(service);
  return {
    props:  {...search, ...pageLayout}
  }
}

export default AllCollectionsPage;
